import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const NeonHowItWorks = () => (
  <section className="nv-section" id="how-it-works">
    <div className="nv-container">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55 }}
      >
        <p className="nv-eyebrow">Process</p>
        <h2 className="nv-title">How It Works</h2>
        <div className="nv-steps">
          {NEONVERSE.steps.map((step, i) => (
            <motion.div
              key={step.title}
              className="nv-step"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.45, delay: i * 0.08 }}
            >
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);

export default NeonHowItWorks;
